/**
 * Generated by orval v7.0.1 🍺
 * Do not edit manually.
 * API V5
 * OpenAPI spec version: v5
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  DocumentRotationResponse,
  ErrorObjectArray,
  ForbiddenErrorObject,
  PutApiV5FirmsDocumentsDocumentUuidRotationBody
} from '.././schemas'
import getApiV5FirmsDocumentsDocumentUuidRotationMutator from '../../configOrvalAPIV5';
import type { ErrorType as GetApiV5FirmsDocumentsDocumentUuidRotationErrorType } from '../../configOrvalAPIV5';
import putApiV5FirmsDocumentsDocumentUuidRotationMutator from '../../configOrvalAPIV5';
import type { ErrorType as PutApiV5FirmsDocumentsDocumentUuidRotationErrorType } from '../../configOrvalAPIV5';



/**
 * @summary Show Document Rotation
 */
export const getApiV5FirmsDocumentsDocumentUuidRotation = (
    documentUuid: string,
 signal?: AbortSignal
) => {
      
      
      return getApiV5FirmsDocumentsDocumentUuidRotationMutator<DocumentRotationResponse>(
      {url: `/api/v5/firms/documents/${documentUuid}/rotation`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiV5FirmsDocumentsDocumentUuidRotationQueryKey = (documentUuid: string,) => {
    return [`/api/v5/firms/documents/${documentUuid}/rotation`] as const;
    }

    
export const getGetApiV5FirmsDocumentsDocumentUuidRotationQueryOptions = <TData = Awaited<ReturnType<typeof getApiV5FirmsDocumentsDocumentUuidRotation>>, TError = GetApiV5FirmsDocumentsDocumentUuidRotationErrorType<ForbiddenErrorObject | ErrorObjectArray>>(documentUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV5FirmsDocumentsDocumentUuidRotation>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV5FirmsDocumentsDocumentUuidRotationQueryKey(documentUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV5FirmsDocumentsDocumentUuidRotation>>> = ({ signal }) => getApiV5FirmsDocumentsDocumentUuidRotation(documentUuid, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(documentUuid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV5FirmsDocumentsDocumentUuidRotation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV5FirmsDocumentsDocumentUuidRotationQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV5FirmsDocumentsDocumentUuidRotation>>>
export type GetApiV5FirmsDocumentsDocumentUuidRotationQueryError = GetApiV5FirmsDocumentsDocumentUuidRotationErrorType<ForbiddenErrorObject | ErrorObjectArray>


/**
 * @summary Show Document Rotation
 */

export function useGetApiV5FirmsDocumentsDocumentUuidRotation<TData = Awaited<ReturnType<typeof getApiV5FirmsDocumentsDocumentUuidRotation>>, TError = GetApiV5FirmsDocumentsDocumentUuidRotationErrorType<ForbiddenErrorObject | ErrorObjectArray>>(
 documentUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV5FirmsDocumentsDocumentUuidRotation>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV5FirmsDocumentsDocumentUuidRotationQueryOptions(documentUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update Document Rotation
 */
export const putApiV5FirmsDocumentsDocumentUuidRotation = (
    documentUuid: string,
    putApiV5FirmsDocumentsDocumentUuidRotationBody: PutApiV5FirmsDocumentsDocumentUuidRotationBody,
 ) => {
      
      
      return putApiV5FirmsDocumentsDocumentUuidRotationMutator<DocumentRotationResponse>(
      {url: `/api/v5/firms/documents/${documentUuid}/rotation`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putApiV5FirmsDocumentsDocumentUuidRotationBody
    },
      );
    }
  


export const getPutApiV5FirmsDocumentsDocumentUuidRotationMutationOptions = <TError = PutApiV5FirmsDocumentsDocumentUuidRotationErrorType<ErrorObjectArray | ForbiddenErrorObject>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV5FirmsDocumentsDocumentUuidRotation>>, TError,{documentUuid: string;data: PutApiV5FirmsDocumentsDocumentUuidRotationBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV5FirmsDocumentsDocumentUuidRotation>>, TError,{documentUuid: string;data: PutApiV5FirmsDocumentsDocumentUuidRotationBody}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV5FirmsDocumentsDocumentUuidRotation>>, {documentUuid: string;data: PutApiV5FirmsDocumentsDocumentUuidRotationBody}> = (props) => {
          const {documentUuid,data} = props ?? {};

          return  putApiV5FirmsDocumentsDocumentUuidRotation(documentUuid,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiV5FirmsDocumentsDocumentUuidRotationMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV5FirmsDocumentsDocumentUuidRotation>>>
    export type PutApiV5FirmsDocumentsDocumentUuidRotationMutationBody = PutApiV5FirmsDocumentsDocumentUuidRotationBody
    export type PutApiV5FirmsDocumentsDocumentUuidRotationMutationError = PutApiV5FirmsDocumentsDocumentUuidRotationErrorType<ErrorObjectArray | ForbiddenErrorObject>

    /**
 * @summary Update Document Rotation
 */
export const usePutApiV5FirmsDocumentsDocumentUuidRotation = <TError = PutApiV5FirmsDocumentsDocumentUuidRotationErrorType<ErrorObjectArray | ForbiddenErrorObject>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV5FirmsDocumentsDocumentUuidRotation>>, TError,{documentUuid: string;data: PutApiV5FirmsDocumentsDocumentUuidRotationBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof putApiV5FirmsDocumentsDocumentUuidRotation>>,
        TError,
        {documentUuid: string;data: PutApiV5FirmsDocumentsDocumentUuidRotationBody},
        TContext
      > => {

      const mutationOptions = getPutApiV5FirmsDocumentsDocumentUuidRotationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    